import { render } from "./TableEventos.vue?vue&type=template&id=307c8212&scoped=true"
import script from "./TableEventos.vue?vue&type=script&lang=js"
export * from "./TableEventos.vue?vue&type=script&lang=js"

import "./TableEventos.vue?vue&type=style&index=0&id=307c8212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307c8212"]])

export default __exports__